<template>
    <div class="modal fade in" id="ModalRecusa">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <p class="modal-title"><i class="fa fa-times-circle-o"></i> Recusar documento:
                        <b>{{file.arquivo_nome}}</b>
                    </p>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                </div>
                <div class="modal-body">
                    <div class="row" v-if="requireDocument">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label :class="{ 'text-danger': errors.has('Documento') }"><i
                                        class="fa fa-list-alt"></i> CPF</label>
                                <input v-mask="'###.###.###-##'" v-validate="{required: true, document: true}"
                                    :class="{ 'is-invalid': errors.has('Documento') }" class="form-control"
                                    name="Documento" v-model="request.assinatura_documento" placeholder="Documento">
                                <div class="invalid-feedback help-block error">{{errors.first('Documento')}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <token-otp ref="inputOtp" @changed="setToken" :tokenTipo="tokenTipo">
                                </token-otp>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label :class="{ 'text-danger': errors.has('Motivo') }">
                                    <required /> Motivo</label>
                                <textarea name="Motivo" v-model="request.motivo"
                                    :class="{ 'is-invalid': errors.has('Motivo') }"
                                    v-validate="{required:true, min: 15}" rows="4"
                                    placeholder="Digite o motivo para recusar o arquivo" class="form-control">
                                </textarea>
                                <div class="invalid-feedback help-block error">{{errors.first('Motivo')}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" data-dismiss="modal" class="btn btn-default float-left"><i
                            class="fa fa-times"></i>
                        {{ $t('words.cancel')}}</button>
                    <button type="button" id="signButton" :disabled="loading" @click="deny()"
                        class="btn btn-danger float-right"><i class="fa fa-thumbs-down"></i>
                        Recusar <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TokenOtp from '../token-otp.vue';
    export default {
        components: {
            TokenOtp
        },
        props: {
            requireDocument: Boolean,
            tokenTipo: String,
        },
        data() {
            return {
                loading: false,
                file: {},
                request: {
                    assinatura_documento: '',
                    motivo: '',
                    token_otp: '',
                }
            }
        },
        methods: {
            setToken(payload) {
                this.request.token_otp = payload;
            },
            deny() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) {
                        return;
                    }
                    this.request.id = this.$route.params.id;
                    this.loading = true;
                    this.$store.dispatch('denyFilePublic', this.request).then(response => {
                        toastr({
                            title: response.message,
                            icon: response.status
                        });
                        $('#ModalRecusa').modal('toggle');
                        setTimeout(() => {
                            this.$router.push(`/validador?arquivo=${this.file.id}`);
                        }, 500)
                    }).catch(error => {
                        toastr({
                            title: error.message,
                            icon: error.status
                        });
                    }).finally(() => {
                        this.loading = false;
                    });
                });
            }
        }
    }
</script>